import React from "react";

function Logo({ children, img, link }) {
  return (
    <div className="navbar-brand">
      <a className="navbar-item" href={link} target="_blank" rel="noopener noreferrer">
        <img src={img} alt="logo" />
      </a>
      {children}
    </div>
  );
}

export default Logo;
